/** The customized theme supports daylight mode only. */
const initTheme = () => {
  document.documentElement.style.colorScheme = 'light'
  document.documentElement.setAttribute('data-preloader', 'light')
  document.documentElement.classList.remove('theme-dark')
  document.getElementById('stylesheet-theme-dark')?.remove()
  try {
    localStorage.setItem('preferredThemeMode', 'light')
  } catch (e) {
    // Storage can be unavailable in private browsing.
  }
}

export default initTheme
